// Dependencies
import styled from 'styled-components';

const BlogPostExcerptStyles = styled.section`
  text-align: ${(props) => (props?.noImage ? 'center' : 'left')};

  .featured-img-wrap {
    width: 100%;
    max-height: 31.25rem;
  }

  .excerpt-wrap {
    padding: 3rem 0 3.688rem;
    background-color: var(--color-sand);
  }

  @media (min-width: 768px) {
    position: relative;
    margin: 0 0 5rem;

    .featured-img-wrap {
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;
      height: 100%;
    }

    .excerpt-wrap {
      display: flex;
      justify-content: flex-end;
      min-height: 31.25rem;
      min-height: ${(props) => (props?.noImage ? '15rem' : '31.25rem')};
      padding: 7.188rem 0;

      .excerpt-inner {
        width: ${(props) => (props?.noImage ? 'auto' : 'calc(50% - 3rem)')};

        * {
          max-width: 34.375rem;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .excerpt-wrap {
      .excerpt-inner {
        width: ${(props) => (props?.noImage ? 'auto' : 'calc(50% - 6.25rem)')};
      }
    }
  }
`;

export default BlogPostExcerptStyles;
